import { withErrorBoundary } from "@sentry/react";

import ErrorFallback from "@components/error-fallback/error-fallback";
import IntegrationLogo from "@components/integration-logo/integration-logo";
import { IntegrationLogoType } from "@components/integration-logo/integration-logo-helpers";
import { classNames } from "@helpers/css";
import { isValidUrl } from "@helpers/helpers";

const AskAIEmbedExternalEventComponent = ({
  eventType,
  eventData,
}: {
  eventType?: string;
  eventData?: any;
}) => {
  const linkClassName = "hover:underline font-medium";
  const source = eventType || "";

  const integrationType = source.startsWith("youtrack")
    ? IntegrationLogoType.YouTrack
    : source.startsWith("jira")
      ? IntegrationLogoType.Jira
      : source.startsWith("hubspot")
        ? IntegrationLogoType.Hubspot
        : source.startsWith("github")
          ? IntegrationLogoType.Github
          : source.startsWith("linear")
            ? IntegrationLogoType.Linear
            : IntegrationLogoType.Topicflow;

  return (
    <div className="flex gap-2 not-prose">
      <div className="mt-1 w-4 h-4">
        <IntegrationLogo type={integrationType} className="block" />
      </div>
      <div className="flex-1">
        {eventData.url && isValidUrl(eventData.url) && eventData?.title ? (
          <a
            href={eventData.url}
            target="_blank"
            rel="noreferrer"
            className={linkClassName}
          >
            {eventData.title}
          </a>
        ) : eventData?.title ? (
          <span className={classNames(linkClassName, "hover:no-underline")}>
            {eventData.title}
          </span>
        ) : (
          <div className="w-64 skeleton rounded-md h-6" />
        )}
      </div>
    </div>
  );
};

const AskAIEmbedExternalEventWithSentry = withErrorBoundary(
  AskAIEmbedExternalEventComponent,
  {
    fallback: ErrorFallback,
  },
);

export default AskAIEmbedExternalEventWithSentry;
